import styled from '@emotion/styled';
import { borderRadii } from 'app/spacing';
import Notice from 'components/Kizen/Notice';
import Section from 'components/Wizards/CustomObject/components/Section';
import BuilderCard from 'components/Wizards/CustomObject/components/BuilderCard';
import BaseSelect from 'components/Inputs/Select';
import { layers } from 'app/spacing';
import Switch from 'components/Kizen/Switch';
import { border } from 'app/colors';
import css from '@emotion/css';
import { CONTENT_MAX_WIDTH } from 'components/Layout/PageContentWidth';
import Loader from 'components/Kizen/Loader';

export const ReverseWrapper = styled.div`
  margin-top: 20px;
  > *:last-child {
    margin-bottom: 14px;
  }
`;
export const PrimaryWrapper = styled.div`
  margin-top: 20px;
  > *:last-child {
    margin-bottom: 14px;
  }
`;
export const StyledBuilderCard = styled(BuilderCard)`
  min-width: ${CONTENT_MAX_WIDTH};
  padding-top: 18px;
  padding-bottom: 240px;
  > h3 {
    padding-bottom: 25px;
  }
`;

export const StyledNotice = styled(Notice)`
  padding-top: 9px;
  padding-bottom: 7px;
  margin-bottom: -1px;
  ${({ noRows }) =>
    noRows &&
    css`
      margin-bottom: 19px;
    `}
`;
export const StyledSection = styled(Section)`
  h3 {
    margin-bottom: 16px;
  }
  margin-bottom: 26px;
  &&:last-child {
    margin-bottom: 3px;
  }
`;

export const Select = styled(BaseSelect)`
  z-index: ${layers.popoverInModal};
`;

export const LineItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 235px 150px repeat(2, 210px) 218px 280px 28px;
  grid-column-gap: 0;
  padding: 13px 0;
  margin-bottom: 15px;
  ${border}
`;

export const StyledRowItemWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
`;

export const StyledRowItemCard = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 15px;
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? 'var(--color-button-warning-default)'
        : 'var(--color-border-medium)'};
  border-radius: ${borderRadii.small};
`;

export const StyledRowItemSwitch = styled(Switch)`
  height: 100%;
  & > div {
    margin-bottom: 20px;
  }
`;

export const StyledDiv = styled.div`
  ${({ width }) => css`
    width: ${width}px;
  `}
`;

export const TimelineSwitch = styled(Switch)`
  margin: 0;

  label {
    margin: 0;
  }
`;

export const EditTextWrapper = styled.div`
  & > * {
    display: block !important;
  }
`;

export const StyledLoader = styled(Loader)`
  padding-top: 20px !important;
  padding-bottom: 18px;
`;

export const AssociationHeader = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
  gap: 0 15px;
  margin-bottom: 30px;
`;
